function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke:#d9d9d9;}.cls-2{fill:none;stroke-miterlimit:54.86;stroke-width:13.71px;}.cls-3{fill:#fff;}.cls-4{fill:url(#Unbenannter_Verlauf);}.cls-5{fill:url(#Unbenannter_Verlauf_2);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Unbenannter_Verlauf",
  cx: -42.8,
  cy: 1062.44,
  r: 0.8,
  gradientTransform: "matrix(262.96, 0, 0, -296.83, 11498.14, 315819.18)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fc0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#ffc800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#ffbd00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#ffab00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#ff9100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#ff7000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#ff4700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#ff1800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "red"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Unbenannter_Verlauf_2",
  cx: -42.69,
  cy: 1062.4,
  r: 0.98,
  gradientTransform: "matrix(196.27, 0, 0, -297.17, 8495.54, 316183.52)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00b4e6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#00b0e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#01a5db"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#0292cd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#0377ba"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#0455a1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#054696"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1-2",
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M160.76,5.56h1157.5a155.79,155.79,0,0,1,155.8,155.8v712.4a155.79,155.79,0,0,1-155.8,155.8H160.76A155.79,155.79,0,0,1,5,873.76V161.36A155.86,155.86,0,0,1,160.76,5.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M162.26,6.86A155.43,155.43,0,0,0,6.86,162.26v710.5a155.43,155.43,0,0,0,155.4,155.4h1154.6a155.43,155.43,0,0,0,155.4-155.4V162.26a155.43,155.43,0,0,0-155.4-155.4Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape1",
  className: "cls-3",
  d: "M448.46,631.06c0,5.7-4,12.6-9,15.4l-174.1,100.7c-5,2.8-13,2.8-18,0l-174-100.6c-5-2.8-9-9.7-9-15.4V429.76c0-5.7,4-12.6,9-15.4l174-100.7c5-2.8,13-2.8,18,0l174,100.7c5,2.8,9,9.7,9,15.4l.1,201.3Zm966.2-186.8h-155.8v37.3h56v159.2H1359V481.46h55.7Zm-707.8,0h-156v37.3h56v159.2H651V481.46h56Zm451-6.2c-49.1,0-76.4,31.3-76.4,76.7v126.1h43.6V513.76c0-19.7,11.6-34.9,33.2-34.9s33,18,33,34.9v127h43.6v-126c.3-45.4-27.9-76.7-77-76.7Zm-164.6,6.2v196.5h43.6V444.26Zm-147.9,77.8,1.4,8.8,41,109.9h17.8l55.7-196.6h-42.9l-26.6,103.3-1.7,11.2-2.1-11.2-35.6-103.3h-14.2l-35.6,103.3-2.1,11.2-1.4-11.2-26.6-103.3h-43.1l55.7,196.6h17.8l41-109.9,1.5-8.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape2",
  className: "cls-4",
  d: "M347.16,530.86l-45.5,66.7L278.36,562l26.8-40.1c5-7.1,15.6-26.8,3.3-53.7-10-21.8-31.5-32.3-50.5-32.3s-39.6,9.7-50.7,32.3c-12.6,25.9-1.7,46.1,3.1,53,0,0,14.9,21.8,27.3,40.4l20.2,29.2,30.4,46.5c.2.2,5,7.6,13.5,7.6,8.1,0,13-7.4,13.8-8.1l71.1-105.4h-39.4l-.1-.5Zm-89.4,1.7s-11.9-18-19.7-30.6c-8.3-13.5.9-33.7,19.7-33.7s28,20.2,19.7,33.7C269.86,514.46,257.76,532.56,257.76,532.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M214.16,595.46l-44.6-62.7s-11.9-18-19.7-30.6c-8.3-13.5.9-33.7,19.7-33.7a20.27,20.27,0,0,1,6.6.9l15.6-28.7a56.19,56.19,0,0,0-22-4.7c-19,0-39.6,9.7-50.7,32.3-12.6,25.9-1.7,46.1,3.1,53l78,115.6c.7.9,5.7,8.3,14,8.3s13-7.1,13.8-8.1l23.5-35.9-20.2-29.7-17.1,24Z"
})));

var SvgTwint = function SvgTwint(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1479.11 1035.01",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twint.b9a60434.svg";
export { ForwardRef as ReactComponent };